import React from 'react';
import { ProjectContent, ProjectImage } from '../styles/TipsTabStyles';
import { SectionDescription } from '../../shared/TabStyles';

const StayingOrganized = () => (
  <div>
    <h2 style={{ textAlign: 'center', color: 'var(--primary-color)', fontSize: '1.8rem', fontWeight: 700, marginBottom: '1.5rem' }}>Staying Organized & Keeping Context</h2>
    <ProjectContent>
      <div>
        <SectionDescription style={{ textAlign: 'left' }}>
          Tired of losing track of your AI conversations?<br />
          With the Projects Folder, you can group chats, notes, and documentation — all in one place. Available in ChatGPT and Abacus.AI
        </SectionDescription>
        <p><strong>🗂 Group Related Threads</strong><br />
          Keep everything tied to a topic, goal, or client.</p>
        <p><strong>🧠 Context That Sticks</strong><br />
          Your AI remembers important details within each project, so you don't have to repeat yourself.</p>
        <p><strong>📄 Docs + Dialogue in One Place</strong><br />
          Store ideas, plans, and chat outputs right next to your conversations.</p>
        <p><strong>🔁 Work Over Time</strong><br />
          Come back later — everything's still there, just as you left it.</p>
      </div>
      <ProjectImage src="/projectsimg.png" alt="Project interface example" />
    </ProjectContent>
  </div>
);

export default StayingOrganized; 